
var article = `
## Problema 1

A veces Git me tira un error al hacer push, algo así:

>! [rejected]        master -> master (non-fast-forward)
>error: failed to push some refs to 'https://github.com/garciapereirajuan/to-do_react-mongoose.git'
>hint: Updates were rejected because the tip of your current branch is behind
>hint: its remote counterpart. Integrate the remote changes (e.g.
>hint: 'git pull ...') before pushing again.
>hint: See the 'Note about fast-forwards' in 'git push --help' for details.

### Solución básica

Lo primero que intento es:

> git push -f origin master **(-f es igual a --force)**

Pero a veces *tampoco funciona*.

### Solución alternativa
          
El *mismo error* recomienda hacer **git pull...** 

Entonces hago:

> git pull origin master

Pueden haber dos resultados:

1. Puede que ya lo haya **solucionado**.

2. Puede que obtenga *otro error*:

>From https://github.com/garciapereirajuan/repo
>*branch            master     -> FETCH_HEAD
>fatal: refusing to merge unrelated histories
          
Si tiene este error entonces **la solución** es hacer *pull* con la bandera **--allow-unrelated-histories**.

De esta forma:

> git pull origin master **--allow-unrelated-histories**
          
Después debería funcionar el **push**.

## Problema 2

Cuando un directorio se sube como **submódulo** y aparece su *ícono con una flecha* en github, es porque ese directorio tiene un directorio **.git** adentro.

Solamente hay que *eliminar* dicho directorio (solamente el directorio **.git** que está adentro del directorio que intento subir) y **subirlo de nuevo**.

## Problema 3

>hint: Updates were rejected because the remote contains work that you do
>hint: not have locally. This is usually caused by another repository pushing
>hint: to the same ref. You may want to first integrate the remote changes
>[....]

Acá simplemente se ejecuta:

> git push -f origin master
`

export default article